module.exports = __webpack_public_path__ + "static/media/ice-cream.3d644dc1.jpg";